/**
 * @flow
 * @relayHash a5aabe5328df2e1bdb93d5966f22cee8
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteInvoiceInput = {|
  id: string
|};
export type DeleteInvoiceMutationVariables = {|
  input: DeleteInvoiceInput
|};
export type DeleteInvoiceMutationResponse = {|
  +deleteInvoice: {|
    +deletedId: string
  |}
|};
export type DeleteInvoiceMutation = {|
  variables: DeleteInvoiceMutationVariables,
  response: DeleteInvoiceMutationResponse,
|};
*/


/*
mutation DeleteInvoiceMutation(
  $input: DeleteInvoiceInput!
) {
  deleteInvoice(input: $input) {
    deletedId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteInvoiceInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteInvoice",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteInvoicePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteInvoiceMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteInvoiceMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteInvoiceMutation",
    "id": null,
    "text": "mutation DeleteInvoiceMutation(\n  $input: DeleteInvoiceInput!\n) {\n  deleteInvoice(input: $input) {\n    deletedId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '34c48624500b18e62731c368056b0753';
module.exports = node;
